import { gql } from "@apollo/client";
import { AccountGroupDropdownData } from "../../../../Utils/AllPagesQuriesAndMutations";

export const AccountGroupData = gql`
  query SearchAccountGroups($id: ID, $keyword: String) {
    searchAccountGroups(id: $id, keyword: $keyword) {
      _id
      Account_Group
      Unique_Id
      Search_Value
    }
  }
`;

export const SalaryAccountConfig = [
  {
    name: "Salary_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Name",
        label: "Name",
        type: "text",
        FirstCharCap: true,
        isRequired: true,
        ValidationType: "VALID_STRING",
        autoFocus: true,
      },
      {
        id: Math.random() * 10,
        name: "Address_Line_One",
        label: "Address",
        type: "textarea",
        FirstCharCap: true,
      },
      {
        id: Math.random() * 10,
        name: "Pincode",
        label: "Pincode",
        type: "number",
        min: 6,
        max: 6,
        ValidationType: "VALID_NUMBER",
      },
      {
        id: Math.random() * 10,
        name: "Sidebyside",
        Subfields: [
          {
            id: Math.random() * 10,
            name: "City",
            label: "City",
            setvalue: "City",
            disable: true,
            type: "text",
            FirstCharCap: true,
          },
          {
            id: Math.random() * 10,
            name: "State",
            label: "State",
            disable: true,
            setvalue: "State",
            type: "text",
            FirstCharCap: true,
          },
        ],
      },
      {
        id: Math.random() * 10,
        name: "Sidebyside",
        Subfields: [
          {
            id: Math.random() * 10,
            name: "Mobile_Number",
            label: "Mobile Number",
            type: "number",
            min: 10,
            max: 10,
            ValidationType: "VALID_NUMBER",
          },
          {
            id: Math.random() * 10,
            name: "Land_Line",
            label: "Land Line",
            type: "number",
            min: 11,
            max: 11,
          },
        ],
      },
      {
        id: Math.random() * 10,
        name: "Email",
        label: "Email",
        type: "text",
        ValidationType: "EMAIL",
      },
      {
        id: Math.random() * 10,
        name: "Pan_Number",
        label: "Pan Number ",
        type: "text",
        min: 10,
        max: 10,
        AllCaps: true,
        ValidationType: "PAN",
      },
      {
        id: Math.random() * 10,
        name: "Aadhar_Number",
        label: "Aadhar Number",
        type: "inputMask",
        mask: "9999-9999-9999",
        min: 12,
        max: 12,
        ValidationType: "AADHAAR",
      },
    ],
  },
  {
    name: "VerticalSection",
    sections: [
      {
        name: "Bank_Details",
        VerticalSection: true,
        fields: [
          {
            id: Math.random() * 10,
            name: "Description",
            label: "Description",
            type: "textarea",
            FirstCharCap: true,
          },
          {
            id: Math.random() * 10,
            name: "Account_Group",
            label: "Account Group ",
            masterName: "Account_Group",
            type: "InputDropForQuery",
            dropdowndata: AccountGroupDropdownData,
          },
        ],
      },
      {
        name: "Account_Details",
        VerticalSection: true,
        fields: [
          {
            id: Math.random() * 10,
            name: "IFSC_Code",
            label: "IFSC Code",
            type: "text",
            min: 11,
            max: 11,
            AllCaps: true,
            ValidationType: "IFSC",
          },
          {
            id: Math.random() * 10,
            name: "Account_Number",
            label: "Account Number",
            type: "text",
            min: 9,
            max: 22,
            ValidationType: "VALID_NUMBER",
          },
        ],
      },
      {
        name: "Balance_Details",
        VerticalSection: true,
        fields: [
          {
            id: Math.random() * 10,
            name: "Balance_Method",
            label: "Balance_Method",
            type: "inputdrop",
            dropdowncontent: ["Balance Only", "Bill By Bill"],
          },
          {
            id: Math.random() * 10,
            name: "Sidebyside",
            Subfields: [
              {
                id: Math.random() * 10,
                name: "Opening_Balance",
                label: "Opening Balance",
                type: "number",
              },
              {
                id: Math.random() * 10,
                name: "Credit_Or_Debit",
                label: "Cr/Db",
                type: "inputdrop",
                dropdowncontent: ["Cr", "Db"],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Documents",
    label: "Documents",
    fields: [
      {
        id: Math.random() * 10,
        name: "Aadhar_Card",
        label: "Aadhar Card",
      },
      {
        id: Math.random() * 10,
        name: "Pan_Card",
        label: "Pan Card",
      },
      {
        id: Math.random() * 10,
        name: "Self_Photo",
        label: "Self Photo",
      },
      {
        id: Math.random() * 10,
        name: "Cancelled_Cheque",
        label: "Cancelled Cheque",
      },
      {
        id: Math.random() * 10,
        name: "Self_Declaration_video",
        label: "Self Declaration video",
      },
      {
        id: Math.random() * 10,
        name: "Other_Doc_1",
        label: "Other Doc 1",
      },
      {
        id: Math.random() * 10,
        name: "Other_Doc_2",
        label: "Other Doc 2",
      },
    ],
  },
];

export const DefaultConfiguration = [
  {
    id: Math.random() * 10,
    name: "Config_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "accountgroups",
        label: "Default Account Group ",
        masterName: "Account_Group",
        type: "InputDropForQuery",
      },
    ],
  },
];